/** @jsxRuntime classic */
import 'react-app-polyfill/ie11';
import '@iwoca/orion/lib/css/orion.css';
import 'core-js/features/string/includes';
import 'core-js/features/string/repeat';
import 'regenerator-runtime/runtime';
import { Logger } from '@iwoca/frontend-logging';

import React from 'react';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import ReactDOM from 'react-dom';

import App from './App';
import { isIwocaDE } from './countryHelper';
import { dynamicActivate } from './il8n';
import './index.css';

import { BrowserRouter } from 'react-router-dom';

function getRuntimeEnvironment() {
  return window.location.host.includes('stage') ? 'staging' : 'production';
}

const isProductionBuild =
  process.env.NODE_ENV === 'production' && !process.env.STORYBOOK_BUILD;
Logger.initialise({
  isProductionBuild,
  isUnitTestEnv: import.meta.env.NODE_ENV === 'test',
  productionClientToken: import.meta.env
    .REACT_APP_DATADOG_PRODUCTION_CLIENT_TOKEN as string,
  stagingClientToken: import.meta.env
    .REACT_APP_DATADOG_STAGING_CLIENT_TOKEN as string,
  service: 'login-ui',
  environment: getRuntimeEnvironment(),
  version: import.meta.env.REACT_APP_RELEASE,
});

const I18nApp = () => {
  React.useEffect(() => {
    // With this method we dynamically load the catalogs
    dynamicActivate(isIwocaDE() ? 'de' : 'en');
  }, []);

  return (
    <BrowserRouter>
      <I18nProvider i18n={i18n}>
        <App />
      </I18nProvider>
    </BrowserRouter>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <I18nApp />
  </React.StrictMode>,
  document.getElementById('root')
);
